export * from './TypographyAlign';
export * from './TypographyBold';
export * from './TypographyColor';
export * from './TypographyTransform';
//# sourceMappingURL=index.js.map